import actions from '@/config/actions';
import mutations from '@/config/mutations';
import AuthService from '@/service/auth/authService';

const LOGIN_ACTIONS = actions.auth;
const MUTATIONS = mutations.auth;

export default {
  state: {
    token: null,
  },
  mutations: {
    [MUTATIONS.SET_TOKEN](state, payload) {
      // eslint-disable-next-line
      state.token = payload;
    },
  },
  actions: {
    [LOGIN_ACTIONS.LOGIN](context, { username, password, fingerprint }) {
      return AuthService.authorize(username, password, fingerprint);
    },
    [LOGIN_ACTIONS.LOGGED_IN]({ commit }, payload) {
      const session = payload
        ? { session: true, expires_in: payload.expires_in }
        : { session: true };
      commit(MUTATIONS.SET_TOKEN, session);
      AuthService.setToken(payload || {});
    },
    [LOGIN_ACTIONS.LOGOUT]({ commit }) {
      commit(MUTATIONS.SET_TOKEN, null);
      AuthService.setToken(null);
    },
  },
};
